import type { Meta } from '../db/tipos'
import { converterNumeroBR } from '../lib/textoBR'
import type { Sugestao } from './bases'

// O que cada campo da tela mostra quando a sugestao chega.
//
// ⚠ Alvo ZERO nasce em BRANCO. Um tipo sem historico nenhum (comissao antes do
// primeiro lancamento, cobertura no comeco) e sugerido com zero, e "meta de
// zero" nao e meta. Preenchido com "0" o campo era recusado por lerAlvos e
// travava TODAS as outras metas junto, reclamando de um numero que o proprio
// app tinha posto ali. Achado pelo E2E em 2026-08-06.
export function camposIniciais(sugestoes: Sugestao[]): Record<string, string> {
  const campos: Record<string, string> = {}
  for (const s of sugestoes) campos[s.tipo] = s.alvo > 0 ? String(s.alvo) : ''
  return campos
}

export interface MetaParaGravar {
  tipo: Meta['tipo']
  valor: number
}

export interface LeituraDosAlvos {
  metas: MetaParaGravar[]
  invalidos: Meta['tipo'][]
}

// Le o que ela digitou nos campos de meta sugerida.
//
// ⚠ A distincao que importa e entre VAZIO e ILEGIVEL:
// - vazio  = intencao ("nao quero esta meta este mes") -> sai calado
// - preenchido e ilegivel, zero ou negativo = erro de digitacao -> vira aviso
//
// Tratar os dois como a mesma coisa (era o `continue` unico do plano) faz a
// meta sumir sem explicacao: ela salva, volta para a lista e simplesmente nao
// esta la. Mesma familia de [[achado-sync-diz-sincronizado-com-falha]].
export type LeituraDeCampo =
  | { estado: 'vazio' }
  | { estado: 'ok'; valor: number }
  | { estado: 'invalido' }

// A leitura de UM campo. Mora aqui, e nao em quem chama, para a regra da
// virgula decimal e a distincao vazio/ilegivel ficarem num lugar so -- o
// criador indexa os campos por tipo, o repetir por linha (la o mesmo tipo
// aparece duas vezes, uma pessoal e uma por marca).
export function lerCampoAlvo(texto: string): LeituraDeCampo {
  const limpo = texto.trim()
  if (limpo === '') return { estado: 'vazio' }
  const valor = converterNumeroBR(limpo)
  if (valor === null || valor <= 0) return { estado: 'invalido' }
  return { estado: 'ok', valor }
}

export function lerAlvos(
  tipos: Meta['tipo'][],
  digitados: Record<string, string>,
): LeituraDosAlvos {
  const metas: MetaParaGravar[] = []
  const invalidos: Meta['tipo'][] = []

  for (const tipo of tipos) {
    const leitura = lerCampoAlvo(digitados[tipo] ?? '')
    if (leitura.estado === 'vazio') continue
    if (leitura.estado === 'invalido') {
      invalidos.push(tipo)
      continue
    }
    metas.push({ tipo, valor: leitura.valor })
  }

  return { metas, invalidos }
}
